import React, { useEffect, useState } from 'react'
import List from '../../../components/Production/Submitted/ConfirmationOfVesselCompletionAndDelivery/list'
import SearchFilter from '../../../components/Production/Submitted/ConfirmationOfVesselCompletionAndDelivery/searchFilter'
import Layout from '../../../components/common/pageLayout'
import { v3_NewBuildingConfirmationOfVesselCompletionAndDelivery } from '../../../actions/v3/productionForm'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import constant from '../../../constant'
import { toast } from 'react-toastify'
import { replacePageState } from '../../../utils';

const NewBuildingBlockInspectionStatus = (props) => {

    const location = useLocation();
    const { page } = location.state || {};
    const [data, setData] = useState({});
    const [currentPage, setCurrentPage] = useState(page || 1);
    const [limit, setLimit] = useState(10);
    const [payload, setPayload] = useState('');
    // Bumped after a delete so the effect below refetches the page.
    const [refreshToken, setRefreshToken] = useState(0);
    useEffect(() => {
        // Requests finish out of order while typing; only the newest may write state.
        let isCurrent = true;
        v3_NewBuildingConfirmationOfVesselCompletionAndDelivery(currentPage, limit, payload).then((res) => {
            if (!isCurrent) return;
            if (res.status) {
                setData(res.result);
                replacePageState(props.history, constant.Authedcomponent.submittedNewBuildingConfirmationOfVesselCompletionAndDelivery.url, {
                    page: currentPage
                });
            } else {
                toast.error(res.error || "Failed to fetch list");
            }
        }).catch((err) => {
            if (!isCurrent) return;
            console.error(err);
            toast.error("Something went wrong");
        });
        return () => { isCurrent = false; };
    }, [currentPage, limit, payload, refreshToken])
    return (
        <Layout
            title='Confirmation of Vessel Completion and Delivery'
        >
            <SearchFilter
                onSearch={(encryptedPayload) => {
                    if (encryptedPayload === payload) return;
                    // A new filter must restart at page 1, else page 3 of the old
                    // result set comes back empty and the search looks broken.
                    setCurrentPage(1);
                    setPayload(encryptedPayload);
                }}
            />
            <List
                setPage={setCurrentPage}
                data={data}
                filterPayload={payload}
            onDeleted={() => setRefreshToken((t) => t + 1)}
            />
        </Layout>
    )
}

export default NewBuildingBlockInspectionStatus